export default "__VITE_ASSET__Dj30H1w5__"